export default __webpack_public_path__ + "ccdb93d24585bd08a4261722b95e9e3d.png";